import React from 'react';
import '../styles.css';
import { Link } from 'react-router-dom';
import AppBar from '../components/AppBar.js';

function MainMenuStudent(props) {
    return (
        <div>
            <AppBar backTo='' />
            <div className='mainMenuDiv'>
                <b className='titleText'>Welcome, {props.identification.name}</b>
                <Link to='/Level Select' className='mainMenuOption'>Level Select</Link>
                <Link to='/Student Progress' className='mainMenuOption'>Progress</Link>
                <Link to='/Profile' className='mainMenuOption'>Profile</Link>
                <button onClick={props.logout} className='mainMenuOption' style={{ backgroundColor: '#423a3a', borderStyle: 'none' }}>Log Out</button>
            </div>
        </div>
    );
}

export default MainMenuStudent;